<template>
  <div class="legend">
    <ul>
      <li v-for="status in getTheatreSeatStatus">
        <span :class="status.status"></span>
        {{ status.readableStatus }}
      </li>
      <li>
        <span class="scanned"></span>
        Skenirano
      </li>
    </ul>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';

export default {
  name: 'TheatreLegend',

  computed: {
    ...mapGetters([
      'getTheatreSeatStatus'
    ])
  }
}
</script>

<style lang="scss">

.legend{
  margin: 40px 0 0;
  ul{
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    list-style-type: none;
    justify-content: center;
    width: calc(100% - 350px);
    padding: 0;
  }

  li{
    position: relative;
    padding-left: 30px;
    margin-bottom: 25px;
    & + li{
      margin-left: 25px;
    }
  }

  span{
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    display: inline-block;
    width: 15px;
    height: 15px;
    border-radius: 50%;
    margin-right: 10px;
    /*&:before{
      position: absolute;
      content: "";
      top: 1px;
      left: 1px;
      right: 1px;
      bottom: 1px;
      background-image: url('https://upload.wikimedia.org/wikipedia/commons/thumb/f/f9/Five_Pointed_Star_Solid.svg/260px-Five_Pointed_Star_Solid.svg.png');
      filter: invert(100%);
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center center;
      transform: translateY(-1px);
    }*/
  }

  .scanned{
    box-shadow: 0px 0px 1px 3px #34a853;
  }

  .available{
    background-color: #34a853;
  }

  .unavailable{
    background-color: #ffdab9;
  }

  .online_sold{
    background-color: #ff5252;
  }

  .used_in_performance{
    background-color: #5532ff;
  }

  .online_checkout{
    background-color: #e9e9e9;
  }

  .offline_sold{
    background-color: #970a0a;
  }

  .offline_checkout{
    background-color: #e9e9e9;
  }

  .reservation{
    background-color: #005bf5;
  }

  .lease{
    background-color: #8844ff;
  }

  .sponsor{
    background-color: #efa135;
  }

  .theatre_manager{
    background-color: #a77b6b;
  }

  .partner_checkout{
    background-color: #859812;
  }

  .partner_sold{
    background-color: #6ddeec;
  }

  .system_reserve{
    background-color: #333;
  }

  .subscription{
    background-color: #123456;
  }

  .locked{
    background-color: #654321;
  }

  .zamjena_web {
    background-color: #f7ff6f;
  }

  .zamjena_pretplata {
    background-color: #7d7d7d;
  }
 
  .zamjena_rezervirano {
    background-color: #ff0080;
  }

  .protocol {
    background-color: #9c3997;
  }

  .premiere {
    background-color: #9e4a19;
  }

  .najam {
    background-color: #ee66c5;
  }

  .press {
    background-color: #7e6e44;
  }

  .in_guests {
    background-color: #be7713;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Theatre/TheatreLegend.vue